<!--
 * @Author: DESKTOP-ROEB53E\caiyangjie 1760178806@qq.com
 * @Date: 2024-01-03 14:38:24
 * @LastEditors: DESKTOP-ROEB53E\caiyangjie 1760178806@qq.com
 * @LastEditTime: 2024-01-04 16:28:59
 * @FilePath: \合联\oms\src\view\analysis\billFirstAnalysis\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!--
 * @Author: DESKTOP-ROEB53E\caiyangjie 1760178806@qq.com
 * @Date: 2024-01-03 14:38:24
 * @LastEditors: DESKTOP-ROEB53E\caiyangjie 1760178806@qq.com
 * @LastEditTime: 2024-01-03 14:44:08
 * @FilePath: \合联\oms\src\view\analysis\billFirstAnalysis\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
    <template #header>
      <Tabs type="card" v-model="tabName" @on-click="handleTab">
        <TabPane
          v-for="(item, idx) in tabList"
          :key="idx"
          :label="item.label"
          :name="item.value"
        />
      </Tabs>
    </template>
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { apis } from "@/api/analysis/billFirstAnalysis";
export default {
  name: "billFirstAnalysis",
  components: {
    cTable
  },
  methods: {
    handleTab(tab) {
      this.tabName = tab;
      this.config["showOverflow"] = tab === "2" ? false : true;
      this.$refs["table"].pageConfig.page = 1;
      this.$refs["table"].pageConfig.size = 15;
      this.$refs["table"].resize();
      this.$refs["table"].getList();
    }
  },
  data() {
    return {
      tabList: [
        {
          label: this.$tz("国家"),
          value: "top"
        },
        {
          label: this.$tz("航司"),
          value: "agent"
        }
      ],
      tabName: "top",
      methods: {
        ...apis,
        list: p => {
          return apis[this.tabName](p);
        },
        beforeHandleList({ data }) {
          return data;
        }
      },
      config: {
        mergeRows: ["country"]
      },
      footer: {
        show: () => false
      },
      modals: {},
      header: {
        searchs: [
          {
            key: "month",
            placeholder() {
              return this.$tz("请选择,月份");
            },
            component: "DatePicker",
            disabledDate: true,
            format: "YYYY-MM",
            bind: {
              type: "month",
              style: {
                width: "150px"
              }
            }
          },
          {
            key: "country",
            placeholder() {
              return this.$tz("目的国");
            },
            component: "Select",
            options: [],
            optionsFn: "toCountry",
            optionsKey: ""
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$tz("导出"),
              type: "export",
              fnName: "export",
              bind: {
                type: "primary"
              },
              disabled() {
                return this.selectAll.length === 0;
              }
            }
          ],
          methods: {
            export() {
              this.exportExc();
            }
          }
        }
      },
      fields: [
        {
          name: () => this.$tz("国家"),
          key: "country",
          minWidth: 130
        },
        {
          name: () => this.$tz("提单,前缀"),
          key: "prefix",
          minWidth: 130,
          show: () => this.tabName === "agent"
        },
        {
          name: () => this.$tz("周期"),
          key: "week",
          minWidth: 130
        },
        {
          name: () => this.$tz("离港,-,到港"),
          key: "ageing1",
          minWidth: 130
        },
        {
          name: () => this.$tz("到港,-,离港"),
          key: "ageing2",
          minWidth: 130
        },
        {
          name: () => this.$tz("离港,-,到达"),
          key: "ageing3",
          minWidth: 130
        },
        {
          name: () => this.$tz("到达,-,清关"),
          key: "ageing4",
          minWidth: 130
        },
        {
          name: () => this.$tz("清关,-,到仓"),
          key: "ageing5",
          minWidth: 130
        },
        {
          name: () => this.$tz("总,时效"),
          key: "ageing6",
          minWidth: 130
        }
      ]
    };
  }
};
</script>

<style scoped></style>
